import './styles.scss'

import { useTranslation } from 'react-i18next'

import { isValidArray } from '@/libs/utils/array'

const Equipment = (props) => {
  const { t } = useTranslation()
  const { anchorId = '', equipments } = props

  const renderEquipmentList = () =>
    isValidArray(equipments)
      ? equipments?.map((equipment) => {
        return equipment
          ? (
            <li key={equipment}>
              <span>{equipment}</span>
            </li>
          )
          : null
      })
      : null

  return (
    <div className="equipment__wrapper pt-4 pb-4">
      <h3 id={anchorId}>{t('productDetails.equipment')}</h3>
      <ul className="equipment__list mt-4">{renderEquipmentList()}</ul>
    </div>
  )
}

export default Equipment
